import { render, staticRenderFns } from "./articleSummaryTable.vue?vue&type=template&id=7a404c9b&scoped=true"
import script from "./articleSummaryTable.vue?vue&type=script&lang=ts"
export * from "./articleSummaryTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a404c9b",
  null
  
)

export default component.exports